import type { TutorialViewProps } from "app/pages/sales-intelligence/common-components/TutorialView/TutorialView";
import withEducationDataFromWindow from "app/pages/sales-intelligence/hoc/withEducationDataFromWindow";
import TutorialView from "app/pages/sales-intelligence/common-components/TutorialView/TutorialView";

const TutorialViewContainer = withEducationDataFromWindow<TutorialViewProps>(TutorialView);

export default TutorialViewContainer;
